import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, ViewEncapsulation, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';


import { Subject } from 'rxjs';
import { CfFtDialogService } from '../cf-feedback-template-dialog/cf-ft-dialog.service';
import { OneWebComponentsAngularModule } from '@one/angular';
import { QnSbnDataServiceService } from '../../../services/qn-sbn-data-service.service';
import { CommonModule } from '@angular/common';
import { CfFeedbackTemplateDropdownComponent } from '../cf-feedback-template-dropdown/cf-feedback-template-dropdown.component';

@Component({
  selector: 'dl-cf-feedback-template',
  standalone: true,
  imports:[OneWebComponentsAngularModule,CommonModule,FormsModule,ReactiveFormsModule,CfFeedbackTemplateDropdownComponent],
  templateUrl: './cf-feedback-template.component.html',
  styleUrls: ['./cf-feedback-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CfFeedbackTemplateComponent implements OnInit {
  public formDisabled = false;
  public selectTypeList = [
    { label: 'Checkbox', value: '1', disabled: false },
    { label: 'Question', value: '2', disabled: false },
    { label: 'Dropdown', value: '3', disabled: false },
    { label: 'Radio', value: '4', disabled: false },
    {
      label: 'Attachment',
      value: '5',
      disabled: false
    }
  ];
  public selectMandatoryList = [
    { label: 'Mandatory', value: '1', disabled: false },
    { label: 'Optional', value: '2', disabled: false }
  ];
  public selectPlaceholder = 'Select type...';
  public selectMandatoryPlaceholder = 'Mandatory/Optional';
  public selectWidth = '150px';
  public selectMandatoryWidth = '186px';

  @Input() public isNewFromTemplate: boolean;
  @Input() public addRowData: Subject<any>;
  @Input() public displayedColumns = [];
  @Input() public tableData = [];
  @Output() public isFeedbackOptionAdded = new EventEmitter<boolean>();
  @Output() public isFoRowSelected = new EventEmitter<{ foSelected: any[] }>();
   @Output() public feedbackAddedChange = new EventEmitter<boolean>();
  @Output() public hasUnsavedChanges = new EventEmitter<boolean>();
  public dataSource: any[] = [];
  public selectedRow: any;
  public selectTypeFormControl = new FormControl('');
  public selectMandatoryFC = new FormControl('');
  public selectTextFormControl = new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(500)]);
  public ischeckforTemplate: boolean;
  
  // Drag and drop properties
  public draggedIndex: number | null = null;
  public dragOverIndex: number | null = null;
  public editingIndex: number | null = null;

  public dropdownDialogVisible: boolean = false;
  public currentEditIndex: number | null = null;
  public currentEditElement: any = null;

  constructor(
    private _QnSbnDataService: QnSbnDataServiceService,
    private cfFtDialogService: CfFtDialogService,
    private changeDetectorRef: ChangeDetectorRef,
    // private readonly oneSnackBar?: OneSnackBarService
  ) {}

  ngOnInit(): void {
    this.selectTypeFormControl.setValue(this.selectTypeList[0].label);
    this.selectMandatoryFC.setValue(this.selectMandatoryList[0].label);

    this.addRowData?.subscribe(data => {
      this.dataSource = data.placement === 'before'
        ? [...data.templateData, ...this.dataSource]
        : [...this.dataSource, ...data.templateData];
    });

    this.dataSource = [...this.tableData];

    this._QnSbnDataService.mappingData$.subscribe(observer => {
      this.ischeckforTemplate = !observer['template'];
      if (!this._QnSbnDataService.isEmpty(observer['configureFeedback'])) {
        this.dataSource = [...observer['configureFeedback']];
      }
    });
     this.selectTextFormControl.statusChanges.subscribe(status => {
    if (status === 'INVALID') {
      this._QnSbnDataService.isValidFeedback$.next(false);
    } else if (status === 'VALID') {
      this._QnSbnDataService.isValidFeedback$.next(true);
    }
    });

  }

  public shouldShowFormControls(row: any, index: number): boolean {
    if (this.editingIndex === index) {
      return true;
    }

    if (this.editingIndex !== null) {
      return false;
    }
    
    const hasNoValues = !row.selectType && !row.selectText && !row.selectMandatory;
    if (!hasNoValues) {
      return false;
    }
    
    const firstEmptyIndex = this.dataSource.findIndex(r => 
      !r.selectType && !r.selectText && !r.selectMandatory
    );
    
    return index === firstEmptyIndex;
  }

  public addNewFeedbackOption(elm: any, rowIndex: number, fbType: string, fbText: string, fbMandatory: string): void {
    const existingDropDownOpt = this.dataSource[rowIndex].dropDownOpt;
    this.dataSource[rowIndex] = {
      ...this.dataSource[rowIndex],
      iconSets: this.isNewFromTemplate ? 'delete-icon' : 'more-icon',
      selectType: fbType,
      selectText: fbText,
      selectMandatory: fbMandatory,
      dropDownOpt: (fbType === 'Dropdown' || fbType === 'Radio') ? existingDropDownOpt : undefined
    };

    if (fbType !== 'Dropdown' && fbType !== 'Radio') delete this.dataSource[rowIndex].dropDownOpt;
    if (fbType !== 'Radio') delete this.dataSource[rowIndex].radioOpt;
    this.isFeedbackOptionAdded.emit(true);
    this._QnSbnDataService.isValidFeedback$.next(true);
    this._QnSbnDataService.isFeedbackAdded$.next(true);
    this._QnSbnDataService.isAfoBtnDisabled$.next(false);  
    this.editingIndex = null;
    this.hasUnsavedChanges.emit(false);
    this.resetFormControls();
    // this.oneSnackBar?.open('Feedback option successfully added', OneSnackBarType.SUCCESS);
    this.addProduct(this.dataSource);
    this.changeDetectorRef.detectChanges();
  }

  public deleteFeedbackFromTemplate(elm: any, index: number): void {
    this.dataSource = this.dataSource.filter(item => item !== elm);
    this.addProduct(this.dataSource);
    // this.oneSnackBar?.open('Feedback option successfully deleted', OneSnackBarType.SUCCESS);
  }

  public EditFeedbackFromTemplate(elm: any, index: number): void {
    this._QnSbnDataService.isEdited$.next(true);
    
    const originalLength = this.dataSource.length;
    this.dataSource = this.dataSource.filter(row => 
      row.selectType && row.selectText && row.selectMandatory
    );
    
    if (this.dataSource.length < originalLength) {
      index = this.dataSource.findIndex(row => row === elm);
      this.addProduct(this.dataSource);
    }
    
    const prevType = this.selectTypeList.find(item => item.label === elm.selectType);
    const prevMandatory = this.selectMandatoryList.find(item => item.label === elm.selectMandatory);

    if (this.editingIndex !== null && this.editingIndex !== index) {
      const previousRow = this.dataSource[this.editingIndex];
      if (previousRow && previousRow.iconSets === 'yes-icon') {
        const hasValues = previousRow.selectType && previousRow.selectText && previousRow.selectMandatory;
        this.dataSource[this.editingIndex] = {
          ...previousRow,
          iconSets: hasValues ? (this.isNewFromTemplate ? 'delete-icon' : 'more-icon') : 'yes-icon'
        };
      }
    }
    this.editingIndex = index;

    this.dataSource[index] = {
      ...elm,
      iconSets: 'yes-icon'
    };

    this.selectTypeFormControl.setValue(prevType?.label || this.selectTypeList[0].label);
    this.selectTextFormControl.setValue(elm.selectText || '');
    this.selectMandatoryFC.setValue(prevMandatory?.label || this.selectMandatoryList[0].label);
    this._QnSbnDataService.isEdited$.next(true);
    this._QnSbnDataService.isAfoBtnDisabled$.next(true);
    this._QnSbnDataService.isValidFeedback$.next(true);
    this.hasUnsavedChanges.emit(true);
    this.changeDetectorRef.detectChanges();
  }

  public updateSelectRowStatus(): void {
    const selected = this.dataSource.filter(row => row.selected);
    this.isFoRowSelected.emit({ foSelected: selected });
  }

  private resetFormControls(): void {
    this.selectTypeFormControl.setValue(this.selectTypeList[0].label);
    this.selectMandatoryFC.setValue(this.selectMandatoryList[0].label);
    this.selectTextFormControl.reset();
  }

  public addProduct(newData: any[]): void {
    this._QnSbnDataService.getMappedQnsbnData(newData, 'ConfigureFeedBack');
  }

  // Dummy placeholder methods for dropdown/radio popups (custom UI should handle these now)
  public dropDownFn(index: number, element: any): void {
    const actualType = element.selectType || this.selectTypeFormControl.value;
    this.currentEditIndex = index;
    this.currentEditElement = { ...element, selectType: actualType };
    if (!this.currentEditElement.dropDownOpt) {
      this.currentEditElement.dropDownOpt = [];
    }
    this.dropdownDialogVisible = true;
    this.changeDetectorRef.detectChanges();
  }

  public radioFn(index: number, element: any): void {
    // Trigger custom radio UI (e.g., OWC dialog or slot-based component)
  }

  // Drag and drop methods
  public onDragStart(event: DragEvent, index: number): void {
    this.draggedIndex = index;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/html', index.toString());
    }
    this.changeDetectorRef.detectChanges();
  }

  public onDragOver(event: DragEvent, index: number): void {
    event.preventDefault();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
    this.dragOverIndex = index;
    this.changeDetectorRef.detectChanges();
  }

  public onDragLeave(event: DragEvent): void {
    this.dragOverIndex = null;
    this.changeDetectorRef.detectChanges();
  }

  public onDrop(event: DragEvent, dropIndex: number): void {
    event.preventDefault();
    
    if (this.draggedIndex !== null && this.draggedIndex !== dropIndex) {
      const draggedItem = this.dataSource[this.draggedIndex];
      
      // Remove the dragged item
      this.dataSource.splice(this.draggedIndex, 1);
      
      // Insert at new position
      if (dropIndex > this.draggedIndex) {
        this.dataSource.splice(dropIndex - 1, 0, draggedItem);
      } else {
        this.dataSource.splice(dropIndex, 0, draggedItem);
      }
      
      // Update the service with reordered data
      this.addProduct(this.dataSource);
    }
    
    this.draggedIndex = null;
    this.dragOverIndex = null;
    this.changeDetectorRef.detectChanges();
  }

  public onDragEnd(): void {
    this.draggedIndex = null;
    this.dragOverIndex = null;
    this.changeDetectorRef.detectChanges();
  }

  public getDragClasses(index: number): string {
    let classes = 'feedback-row';
    if (this.draggedIndex === index) {
      classes += ' dragging';
    }
    if (this.dragOverIndex === index && this.draggedIndex !== index) {
      classes += ' drag-over';
    }
    return classes;
  }

  public getFormControlValue(control: FormControl): string {
    const value = control.value;
    if (Array.isArray(value) && value.length > 0) {
      return value[0];
    }
    return value || '';
  }

  public onDropdownDialogConfirm(result: any): void {
    if (this.currentEditIndex !== null && result && result.optArr) {
      const feedbackType = result.feedbackType || this.dataSource[this.currentEditIndex]?.selectType;
      if (feedbackType === 'Radio') {
        this.dataSource[this.currentEditIndex].dropDownOpt = result.optArr;
        this.dataSource[this.currentEditIndex].radioOpt = result.optArr;
        this.dataSource[this.currentEditIndex].FeedbackItemRadio = result.optArr;
        this.dataSource[this.currentEditIndex].FeedbackItemDropdown = []; 
      } else {
        this.dataSource[this.currentEditIndex].dropDownOpt = result.optArr;
        this.dataSource[this.currentEditIndex].FeedbackItemDropdown = result.optArr;
        this.dataSource[this.currentEditIndex].radioOpt = [];
        this.dataSource[this.currentEditIndex].FeedbackItemRadio = [];
      }
      
      this.addProduct(this.dataSource);
    }
    this.dropdownDialogVisible = false;
    this.currentEditIndex = null;
    this.currentEditElement = null;
    this.changeDetectorRef.detectChanges();
  }

  public onDropdownDialogCancel(): void {
    this.dropdownDialogVisible = false;
    this.currentEditIndex = null;
    this.currentEditElement = null;
    this.changeDetectorRef.detectChanges();
  }

  public isConfirmButtonDisabled(row: any, selectType: string, selectText: string): boolean {
    if (!selectText || selectText.trim() === '') {
      return true;
    }
    if (selectType === 'Dropdown' || selectType === 'Radio') {
      if (!row.dropDownOpt || row.dropDownOpt.length === 0) {
        return true;
      }
    }
    return false;
  }
}